module.exports = __webpack_public_path__ + "img/98082c4.jpg";